import { useRef } from "react";

const pad2 = (value) => String(value).padStart(2, "0");

const formatDateTime = (date) =>
  `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}T${pad2(date.getHours())}:${pad2(date.getMinutes())}`;

const DateTimeInput = ({ value, onChange, className = "", ...rest }) => {
  const shortcutOffsetRef = useRef(0);

  const onShortcutKeyDown = (event) => {
    if (event.ctrlKey || event.metaKey) return;
    if (event.key !== " " && event.key !== "-" && event.key !== "+") return;
    event.preventDefault();
    if (event.key === " ") shortcutOffsetRef.current = 0;
    if (event.key === "-") shortcutOffsetRef.current -= 1;
    if (event.key === "+") shortcutOffsetRef.current += 1;
    const date = new Date();
    date.setDate(date.getDate() + shortcutOffsetRef.current);
    onChange(formatDateTime(date));
  };

  return (
    <input
      type="datetime-local"
      value={value ?? ""}
      onChange={(event) => {
        shortcutOffsetRef.current = 0;
        onChange(event.target.value);
      }}
      onKeyDown={onShortcutKeyDown}
      onFocus={() => {
        shortcutOffsetRef.current = 0;
      }}
      className={className}
      {...rest}
    />
  );
};

export default DateTimeInput;
